import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
	ButtonComponent,
	RoutedModalBaseComponent,
	NotificationComponent,
	SlottedModalComponent,
} from '@woolworthsnz/styleguide';
import { BehaviorSubject } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { AddDeliveryAddressComponent } from '@woolworthsnz/fulfilment';
@Component({
	selector: 'wnz-add-delivery-address-modal',
	templateUrl: './add-delivery-address-modal.component.html',
	styleUrls: ['./add-delivery-address-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [SlottedModalComponent, AddDeliveryAddressComponent, ButtonComponent, NotificationComponent, AsyncPipe],
})
export class AddDeliveryAddressModalComponent extends RoutedModalBaseComponent {
	showErrorNotification$ = new BehaviorSubject(false);

	handleError(): void {
		this.showErrorNotification$.next(true);
	}
}
